import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import '../sip/Calculators.css';

const EMI = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8.5);
  const [loanTenure, setLoanTenure] = useState(60);
  const [emiResult, setEmiResult] = useState(null);

  const calculateEMI = () => {
    const monthlyRate = interestRate / (12 * 100);
    const emi =
      (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, loanTenure)) /
      (Math.pow(1 + monthlyRate, loanTenure) - 1);
    const totalPayment = emi * loanTenure;
    const totalInterest = totalPayment - loanAmount;

    setEmiResult({
      emi: emi.toFixed(0),
      totalPayment: totalPayment.toFixed(0),
      totalInterest: totalInterest.toFixed(0),
    });
  };

  const pieData = emiResult && {
    labels: ['Principal', 'Interest'],
    datasets: [
      {
        data: [loanAmount, emiResult.totalInterest],
        backgroundColor: ['#004aad', '#76d041'],
      },
    ],
  };

  return (
    <div className="sip-calculator">
      <h2>EMI Calculator</h2>

      <div className="input-group">
        <label>Loan Amount</label>
        <input
          type="range"
          min="0"
          max="150000000"
          step="1000"
          value={loanAmount}
          onChange={(e) => setLoanAmount(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="150000000"
          value={loanAmount}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setLoanAmount('');
            } else {
              setLoanAmount(Number(val));
            }
          }}
          className="value-box"
        />

      </div>

      <div className="input-group">
        <label>Loan Duration (In Months)</label>
        <input
          type="range"
          min="0"
          max="500"
          step="1"
          value={loanTenure}
          onChange={(e) => setLoanTenure(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="500"
          value={loanTenure}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setLoanTenure('');
            } else {
              setLoanTenure(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <div className="input-group">
        <label>Interest Rate (%)</label>
        <input
          type="range"
          min="0"
          max="100"
          step="0.1"
          value={interestRate}
          onChange={(e) => setInterestRate(Number(e.target.value))}
        />
        <input
          type="number"
          min="0"
          max="100"
          value={interestRate}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '') {
              setInterestRate('');
            } else {
              setInterestRate(Number(val));
            }
          }}
          className="value-box"
        />
      </div>

      <button onClick={calculateEMI} className="calculate-btn">
        Calculate
      </button>

      {emiResult && (
        <div className="sip-output-section">
          <div className="result-summary">
            <h3>EMI Results</h3>
            <p>Monthly EMI: <span>₹ {emiResult.emi}</span></p>
            <p>Total Payment: <span>₹ {emiResult.totalPayment}</span></p>
            <p>Total Interest: <span>₹ {emiResult.totalInterest}</span></p>
          </div>

          <div className="pie-chart-container">
            <h3>Principal vs Interest</h3>
            <Pie data={pieData} />
          </div>
        </div>
      )}
    </div>
  );
};

export default EMI;
